import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MoneyMask, Iestado } from "../../helpers";
import {
  detallePago,
  ServiciosVentas,
  Idocumento,
} from "../../helpers/dataExamples";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import moment from "moment";
import { IconButton, Tooltip } from "@mui/material";

type props = {
  documentos: Array<Idocumento>;
  estado: Iestado;
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>;
  serviciosVentas: Array<ServiciosVentas>;
};

const DocumentoPago: FC<props> = ({
  documentos,
  estado,
  setEstado,
  serviciosVentas,
}) => {
  function activarReferencia(doc: Idocumento, tipoRadio: string) {
    desmarcarTodoslosRadios(doc.referencia);
    //SetReferenciaActiva(ref)
    const referencia = doc.referencia;
    const newState = { ...estado };
    newState.referencias = {};
    newState.referenciaActiva = "";
    //Si ya existe la referencia debe quitarse del arreglo de referencias seleccionadas
    /*if (typeof estado.referencias[referencia] === "object") {
      delete estado.referencias[referencia];
      setEstado(newState);
      return false;
    }*/

    var newReferencia: detallePago = {
      abonable: false,
      descrip: doc.detalle,
      hacer_abono: false,
      limite: doc.vence,
      porMinimoAbono: 0,
      referencia: doc.referencia,
      valorTotal: doc.valorTotal,
      valorMinimo: doc.valorMinimo,
      valorMinimoAbono: 0,
      valor_abono: 0,
      codigoServicio: "",
      codigoServicioSAP: "",
      idServicio: null,
      fechaVencimiento: "",
      tipoPago: tipoRadio
    };

    const aa = { [referencia]: newReferencia };
    Object.assign(newState.referencias, aa);

    let tipoServicio = serviciosVentas.find(
      (srv) => srv.codigoServicio === doc.codigoServicio /*||
        doc.codigoServicio === srv.codigoServicioSap*/
    );
    let vencimiento =
      doc.vence === "00000000"
        ? "No disponible"
        : moment(doc.vence, "DD/MM/YYYY").format("YYYY-MM-DD");
    let minimoAbono =
      typeof tipoServicio?.porcentajeAbono != "undefined"
        ? (doc.valorMinimo * tipoServicio?.porcentajeAbono) / 100
        : 0;
    let tokenEpayco =
      typeof tipoServicio?.tokenEpayco != "undefined"
        ? tipoServicio?.tokenEpayco
        : "";
    let idServicio =
      typeof tipoServicio?.id != "undefined" ? tipoServicio?.id : "";

    newState.tokenEpayco = tokenEpayco;
    newState.idServicio = idServicio;
    newState.referenciaActiva = referencia;
    newState.fechaVencimiento = vencimiento;

    newState.referencias[referencia].valorMinimoAbono = minimoAbono;
    newState.referencias[referencia].referencia = doc.referencia;
    newState.referencias[referencia].descrip = doc.detalle;
    newState.referencias[referencia].valorTotal = doc.valorTotal;
    newState.referencias[referencia].valorMinimo = doc.valorMinimo;
    newState.referencias[referencia].limite = vencimiento;
    newState.referencias[referencia].abonable =
      typeof tipoServicio?.abonable != "undefined";
    newState.referencias[referencia].codigoServicio = doc.codigoServicio;
    newState.referencias[referencia].codigoServicioSAP =
      typeof tipoServicio?.codigoServicioSap != "undefined"
        ? tipoServicio?.codigoServicioSap
        : "";
    newState.referencias[referencia].fechaVencimiento = vencimiento;

    setEstado(newState);
  }

  const eventoRealizarAbono = (
    event: React.ChangeEvent<HTMLInputElement>,
    referencia: string
  ) => {
    const newState = { ...estado };
    let valor: number = parseInt(event.target.value.replace(/\D/g, ""));
    valor = Number.isNaN(valor) ? 0 : valor;
    newState.referencias[referencia].valor_abono = valor;
    newState.referencias[referencia].hacer_abono = valor === 0 ? false : true;
    setEstado(newState);
  };

  const desmarcarTodoslosRadios = (referencia: string) => {
    const nodes: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[type="radio"]:not([name="tipo' + referencia + '"])');
    nodes.forEach((v, k) => {
      v.checked = false;
    });
  }

  /*SE AGRUPAN TODOS LOS SERVICIOS DE VENTA PARA LA PERSONA*/
  let serviciosVentaPersona: Array<ServiciosVentas> = [];

  serviciosVentas.forEach((srv, index) => {
    let incluir = documentos.find(
      (doc) => doc.codigoServicio === srv.codigoServicio /*||
        doc.codigoServicio === srv.codigoServicioSap*/
    );
    if (!serviciosVentaPersona.includes(srv) && incluir) {
      serviciosVentaPersona.push(srv);
    }
  });

  return (
    <>
      <div className="row mt-6 principal-documentosPago">
        <div className="col">
          {documentos.length === 0 ? (
            <p style={{ textAlign: "center" }}>
              No hay documentos disponibles para pago
            </p>
          ) : (
            <div>
              <Tabs>
                <TabList>
                  {/*SOLO SE MUESTRAN LOS GRUPOS DE SERVICOOS EN LOS CUALES EL CLIENTE TENGA DOCUMENTOS*/}
                  {serviciosVentaPersona.map((srv, index) => {
                    return (
                      <Tab key={"Key-Tab-" + index}>
                        <p>{srv.nombre}</p>
                      </Tab>
                    );
                  })}
                </TabList>
                {serviciosVentaPersona.map((srv2, index2) => {
                  return (
                    <TabPanel
                      key={"Key-TabPanel-" + index2}
                      className={"container_documentos_pagos"}
                    >
                      {documentos.map((doc, index3) => {
                        //SI NO COINCIDE EL SERVICIO SE SALTA
                        if (
                          srv2.codigoServicio !== doc.codigoServicio /*&&
                          doc.codigoServicio !== srv2.codigoServicioSap*/
                        ) {
                          return false;
                        }

                        let tipoServicio = serviciosVentas.find(
                          (srv) =>
                            srv.codigoServicio === doc.codigoServicio /*||
                            doc.codigoServicio === srv2.codigoServicioSap*/
                        );
                        let checked =
                          estado.referenciaActiva === doc.referencia;
                        let abonable = tipoServicio?.abonable;
                        let minimoAbono =
                          typeof tipoServicio?.porcentajeAbono != "undefined"
                            ? (doc.valorMinimo *
                              tipoServicio?.porcentajeAbono) /
                            100
                            : 0;
                        minimoAbono = Math.ceil(minimoAbono);
                        let moneyPagoTotal = MoneyMask(doc.valorTotal + "");
                        let moneyPagoMinimo = MoneyMask(doc.valorMinimo + "");
                        let vencimiento =
                          doc.vence === "00000000"
                            ? "No disp."
                            : moment(doc.vence, "DD/MM/YYYY").format(
                              "YYYY-MM-DD"
                            );
                        let tipoPagoRef = typeof (estado.referencias[doc.referencia]) === "undefined" ? "" : estado.referencias[doc.referencia].tipoPago;
                        return (
                          <div
                            className={
                              "referencia-pago " 
                              + (checked ? "active " : " ")
                              + (doc.trans_bloq ? "border-warning " : "")
                            }
                            key={index3}
                          >
                            <label
                              className={
                                "d-flex flex-stack cursor-pointer rounded-2  " +
                                (checked ? "active" : "")
                              }
                              id={"referencia-" + doc.referencia}
                              key={index3}
                            >
                              <span className="d-flex align-items-center me-2 w-100">
                                <span className="symbol symbol-50px me-6 d-xs-none d-sm-none d-dm-block d-lg-block d-none">
                                  <span className="symbol-label bg-light-comfe-b">
                                    <i
                                      className={
                                        "fab fa-html5  fs-2x " +
                                        (checked ? "text-comfe" : "text-muted")
                                      }
                                    ></i>
                                    <FontAwesomeIcon
                                      className={
                                        "fab fa-html5 fs-2x " +
                                        (checked ? "text-comfe" : "text-muted")
                                      }
                                      icon={"dollar-sign"}
                                    />
                                  </span>
                                </span>

                                <div className="d-flex flex-column flex-fill">
                                  <span
                                    className={
                                      "fs-7 mb-2 " + (checked ? "" : "text-muted")
                                    }
                                  >
                                    Ref. {doc.referencia} - {doc.detalle}
                                  </span>
                                  <div className="row">
                                    {/*******PAGO MINIMO*********/}
                                    <div
                                      className={
                                        "row col-12 col-sm-12 col-md-12 col-lg-12 fs-7 text-start mb-2 " +
                                        (checked ? "" : "text-muted ")
                                      }
                                    >
                                      <div className="col-2 col-sm-1 col-md-1 col-lg-1">
                                        <span className="form-check form-check-custom form-check-solid">
                                          <input className={"form-check-input "}
                                            type={"radio"}
                                            value={"min"}
                                            name={"tipo" + doc.referencia}
                                            onChange={(a) => activarReferencia(doc, a.target.value)}
                                            checked={tipoPagoRef === "min" && estado.referenciaActiva === doc.referencia}
                                            disabled={doc.valorMinimo === 0 || doc.trans_bloq}
                                          />
                                        </span>
                                      </div>
                                      <div className="col-10 col-sm-6 col-md-6 col-lg-6">
                                        Pago mínimo: ${moneyPagoMinimo}
                                      </div>
                                      {/*************VENCE 1***********/}
                                      <div className="col-10 col-sm-5 col-md-5 col-lg-5 d-none d-md-block d-lg-block">
                                        Vence: {vencimiento}
                                      </div>
                                      {/***************FIN VENCE 1*******/}

                                      {/*************VENCE 2***********/}
                                      <span
                                        className={
                                          "col-md-12 fs-7 text-start mb-2 offset-2 offset-sm-1 offset-md-1 offset-lg-1 d-lg-none d-md-none d-xs-block d-sm-block" +
                                          (checked ? "" : "text-muted")
                                        }
                                      >
                                        Vence: {vencimiento}
                                      </span>
                                      {/***************FIN VENCE 2*******/}
                                    </div>
                                    {/*******FIN PAGO MINIMO */}


                                    {/*******PAGO TOTAL*********/}
                                    <div
                                      className={
                                        "row col-12 col-sm-12 col-md-12 col-lg-12 fs-7 text-start mb-2" +
                                        (checked ? "" : " text-muted") +
                                        (abonable ? "" : " d-none ") +
                                        (doc.valorTotal === 0 ? " d-none" : "")
                                      }
                                    >
                                      <div className="col-2 col-sm-1 col-md-1 col-lg-1">
                                        <span className="form-check form-check-custom form-check-solid">
                                          <input className={"form-check-input"}
                                            type={"radio"}
                                            value={"tot"}
                                            name={"tipo" + doc.referencia}
                                            onChange={(a) => activarReferencia(doc, a.target.value)}
                                            checked={(tipoPagoRef === "tot" && estado.referenciaActiva === doc.referencia)}
                                            disabled={doc.trans_bloq}>
                                          </input>
                                        </span>
                                      </div>
                                      <div className="col-10 col-sm-11 col-md-11 col-lg-11">Pago total: ${moneyPagoTotal}</div>
                                    </div>
                                    {/*******FIN PAGO TOTAL*********/}

                                    {/*******OTRO VALOR*********/}
                                    {
                                      abonable &&
                                      <div className={
                                        "row col-12 col-sm-12 col-md-12 col-lg-12 fs-7 text-start mb-2" +
                                        (checked ? "" : " text-muted")}>

                                        <div className={"col-2 col-sm-1 col-md-1 col-lg-1 "}>
                                          <span className="form-check form-check-custom form-check-solid">
                                            <input className={"form-check-input mt-1"}
                                              type={"radio"}
                                              value={"otr"}
                                              name={"tipo" + doc.referencia}
                                              onChange={(a) => { activarReferencia(doc, a.target.value); }}
                                              checked={tipoPagoRef === "otr" && estado.referenciaActiva === doc.referencia}
                                              disabled={doc.trans_bloq} />
                                          </span>
                                          <Tooltip
                                            className={tipoPagoRef !== "otr" ? "d-none" : ""}
                                            title={
                                              <h3 style={{ color: "white" }}>
                                                Ingrese un valor comprendido entre{" "}
                                                {MoneyMask(minimoAbono + "")} y{" "}
                                                {MoneyMask(
                                                  (doc.valorTotal === 0
                                                    ? doc.valorMinimo
                                                    : doc.valorTotal) + ""
                                                )}
                                              </h3>
                                            }
                                          >
                                            <IconButton>
                                              <FontAwesomeIcon
                                                icon={"question"}
                                                style={{ fontSize: "0.75rem" }}
                                              />
                                            </IconButton>
                                          </Tooltip>
                                        </div>
                                        <div className="col-10 col-sm-11 col-md-11 col-lg-11">
                                          <span
                                            className={
                                              "mt-2 me-3 " +
                                              (checked ? "" : "text-muted") +
                                              (abonable ? " " : " d-none")
                                            }
                                          >
                                            Otro valor:
                                          </span>
                                          <input
                                            type="text"
                                            className={
                                              "form-control form-control-sm rounded-pill col-md-4 mt-3"}
                                            id="input_abono"
                                            maxLength={
                                              10 /*estado.detalle_pago.valor + "".length*/
                                            }
                                            placeholder="Ingrese el valor a pagar"
                                            value={
                                              checked
                                                ? estado.referencias[doc.referencia]
                                                  .valor_abono
                                                : ""
                                            }
                                            min={minimoAbono}
                                            max={doc.valorTotal}
                                            onChange={(event) =>
                                              eventoRealizarAbono(event, doc.referencia)
                                            }
                                            disabled={!checked || (tipoPagoRef !== "otr" && estado.referenciaActiva === doc.referencia) || doc.trans_bloq}
                                          ></input>
                                        </div>
                                      </div>
                                    }
                                    {/**********FIN OTRO VALOR *********/}

                                    {/********** MENSAJE BLOQUEO *********/}
                                    {(doc.trans_bloq) && <p className="text-end text-warning2"><i><FontAwesomeIcon icon={"exclamation-triangle"}/></i>Transacción en proceso!</p>}
                                    {/**********FIN MENSAJE BLOQUEO *********/}
                                  </div>
                                </div>
                              </span>

                              {/*<span className="form-check form-check-custom form-check-solid d-none">
                                <input
                                  className={"form-check-input "}
                                  type="radio"
                                  name="framework"
                                  value={doc.referencia}
                                  onChange={() => activarReferencia(doc)}
                                  checked={checked}
                                />
                                  </span>*/}
                            </label>


                          </div>
                        );
                      })}
                    </TabPanel>
                  );
                })}
              </Tabs>
              {/*<div>
                Total:{" $ "}
                <b>
                  {MoneyMask(valortotalDocumentosSeleccionados(estado) + "")}
                </b>
              </div>*/}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export { DocumentoPago };
